const TrendingPostSkeleton = ({ viewRef }: any) => {
  return (
    <div className="pl-5 my-5" ref={viewRef}>
      <div className="h-6 bg-surface-200-bg skeleton rounded-3xl w-16" />
      <div className="flex flex-row items-center mt-2.5">
        <div className="w-[80px] h-[30px] bg-surface-200-bg skeleton rounded-3xl mr-1.5" />
        <div className="w-[80px] h-[30px] bg-surface-200-bg skeleton rounded-3xl" />
      </div>
      <div className="mt-2.5 overflow-hidden">
        <div className="w-[477px] flex flex-row items-center ">
          {new Array(3).fill(0).map((_item, index) => {
            return (
              <div
                key={`trend-post-skeleton-${index}`}
                className="w-[148px] h-[238px] ml-2.5 first:ml-0 rounded-400 bg-surface-200-bg skeleton"
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrendingPostSkeleton;
